import { render, staticRenderFns } from "./airLineList.vue?vue&type=template&id=4ff3be50"
import script from "./airLineList.vue?vue&type=script&lang=js"
export * from "./airLineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports